import { Address } from '../../types/api/clients';

export const AddressInitialValues: Address = {
  municipalityId: null,
  municipalityName: '',
  placeId: null,
  placeName: '',
  streetId: null,
  streetName: '',
  housenumber: '',
  entrance: '',
  apartment: '',
  location: null,

  stateId: null,
  countryCode: process.env.REACT_APP_CLIENT_NAME_TITLE ?? 'MK',
  countryId: null,
  cityId: null,
  cityName: null,
  postcode: null,
  rawName: '',
  zoneId: null,
};
